import script from "./TxtInput.vue?vue&type=script&setup=true&lang=js"
export * from "./TxtInput.vue?vue&type=script&setup=true&lang=js"

import "./TxtInput.vue?vue&type=style&index=0&id=785f3550&lang=scss&scoped=true"

import exportComponent from "/media/dolar/office/office_project/oneGov-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-785f3550"]])

export default __exports__